import { useMutation } from '@tanstack/react-query';
import { uploadMedia } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useUploadMedia({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const Request = useMutation({
    mutationFn: uploadMedia,
    mutationKey: ['uploadMedia'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess(data);
      // toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
